var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.value)?_c('span',[_vm._v("\n      "+_vm._s(_vm._f("date")(_vm.value,'yyyy-MM-dd'))+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }